/* BAVELIA — interacciones propias (prefijo mt-). Sin librerías externas. */
(function () {
  'use strict';

  // Varias secciones cargan este archivo: solo se ejecuta la primera vez.
  if (window.mtScriptsCargado) return;
  window.mtScriptsCargado = true;

  var reducir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observadorReveal = null;

  function listo(el) {
    if (el.dataset.mtListo) return true;
    el.dataset.mtListo = '1';
    return false;
  }

  function formatoDinero(moneda) {
    try {
      var f = new Intl.NumberFormat('es-ES', { style: 'currency', currency: moneda || 'EUR' });
      return function (cents) { return f.format(cents / 100); };
    } catch (err) {
      return function (cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; };
    }
  }

  /* ---------- Entradas al hacer scroll ---------- */
  function initReveals(root) {
    var els = root.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (reducir || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!observadorReveal) {
      observadorReveal = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('mt-visible');
            observadorReveal.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    }
    els.forEach(function (el) { observadorReveal.observe(el); });

    // Respaldo: si el observador no llega a disparar, se muestran al pasar por pantalla.
    if (!window.mtRevealRespaldo) {
      window.mtRevealRespaldo = true;
      var pendiente = false;
      var revisar = function () {
        pendiente = false;
        var limite = window.innerHeight * 0.95;
        document.querySelectorAll('.mt-reveal:not(.mt-visible)').forEach(function (el) {
          var caja = el.getBoundingClientRect();
          if (caja.top < limite && caja.bottom > 0) el.classList.add('mt-visible');
        });
      };
      window.addEventListener('scroll', function () {
        if (!pendiente) { pendiente = true; setTimeout(revisar, 150); }
      }, { passive: true });
      setTimeout(revisar, 600);
    }
  }

  /* ---------- Cifras animadas ---------- */
  function initCifras(root) {
    root.querySelectorAll('[data-mt-contar]').forEach(function (el) {
      if (listo(el)) return;
      var original = (el.dataset.mtContar || '').trim();
      var final = parseFloat(original.replace(',', '.'));
      if (isNaN(final) || final === 0) return;
      var decimales = (original.split(/[.,]/)[1] || '').length;
      var duracion = parseInt(el.dataset.mtDuracion || '1800', 10);
      var pintar = function (v) { el.textContent = v.toFixed(decimales).replace('.', ','); };
      if (reducir || !('IntersectionObserver' in window)) return;
      pintar(0);
      var obs = new IntersectionObserver(function (entradas) {
        if (!entradas[0].isIntersecting) return;
        obs.disconnect();
        var t0 = performance.now();
        var paso = function (ahora) {
          var p = Math.min(1, (ahora - t0) / duracion);
          pintar(final * (1 - Math.pow(1 - p, 4)));
          if (p < 1) requestAnimationFrame(paso);
        };
        requestAnimationFrame(paso);
      }, { threshold: 0.4 });
      obs.observe(el);
    });
  }

  /* ---------- Parallax suave ---------- */
  var parallaxEls = [];
  var parallaxActivo = false;
  function actualizarParallax() {
    var alto = window.innerHeight;
    parallaxEls.forEach(function (el) {
      var f = parseFloat(el.dataset.mtParallax) || 0;
      var caja = el.parentElement.getBoundingClientRect();
      if (!f || caja.bottom < 0 || caja.top > alto) return;
      var progreso = (caja.top + caja.height / 2 - alto / 2) / alto;
      el.style.setProperty('--mt-parallax', (progreso * -f * 3).toFixed(1) + 'px');
    });
    parallaxActivo = false;
  }
  function initParallax(root) {
    if (reducir) return;
    root.querySelectorAll('[data-mt-parallax]').forEach(function (el) {
      if (!listo(el)) parallaxEls.push(el);
    });
    if (!parallaxEls.length || window.mtParallaxEscuchando) return;
    window.mtParallaxEscuchando = true;
    window.addEventListener('scroll', function () {
      if (!parallaxActivo) { parallaxActivo = true; requestAnimationFrame(actualizarParallax); }
    }, { passive: true });
    actualizarParallax();
  }

  /* ---------- Comparador antes / después ---------- */
  function initComparadores(root) {
    root.querySelectorAll('.mt-comparador').forEach(function (c) {
      if (listo(c)) return;
      var rango = c.querySelector('.mt-comparador__rango');
      if (!rango) return;
      var fijar = function (v) { c.style.setProperty('--pos', v + '%'); };
      rango.addEventListener('input', function () { fijar(rango.value); c.dataset.mtTocado = '1'; });
      fijar(rango.value);
      if (reducir || !('IntersectionObserver' in window)) return;
      var obs = new IntersectionObserver(function (entradas) {
        if (!entradas[0].isIntersecting) return;
        obs.disconnect();
        var inicio = parseFloat(rango.value);
        var t0 = performance.now();
        var paso = function (ahora) {
          if (c.dataset.mtTocado) return;
          var p = Math.min(1, (ahora - t0) / 1600);
          var v = inicio + Math.sin(p * Math.PI * 2) * 12 * (1 - p);
          fijar(v.toFixed(2));
          if (p < 1) requestAnimationFrame(paso); else fijar(inicio);
        };
        setTimeout(function () { requestAnimationFrame(paso); }, 300);
      }, { threshold: 0.6 });
      obs.observe(c);
    });
  }

  /* ---------- Escena fija de detalles ---------- */
  function initDetalles(root) {
    root.querySelectorAll('.mt-det').forEach(function (sec) {
      if (listo(sec)) return;
      var items = Array.prototype.slice.call(sec.querySelectorAll('.mt-det__item'));
      var imgs = Array.prototype.slice.call(sec.querySelectorAll('.mt-det__img'));
      var contador = sec.querySelector('[data-mt-det-actual]');
      if (!items.length) return;
      var activar = function (i) {
        items.forEach(function (it, k) { it.classList.toggle('is-activo', k === i); });
        imgs.forEach(function (im, k) { im.classList.toggle('is-activa', k === i); });
        if (contador) contador.textContent = String(i + 1).padStart(2, '0');
      };
      activar(0);
      if (!('IntersectionObserver' in window)) return;
      var obs = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) activar(items.indexOf(e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      items.forEach(function (it) { obs.observe(it); });
    });
  }

  /* ---------- Galería de producto ---------- */
  function initGalerias(root) {
    root.querySelectorAll('[data-mt-galeria]').forEach(function (g) {
      if (listo(g)) return;
      var slides = Array.prototype.slice.call(g.querySelectorAll('.mt-galeria__slide'));
      var minis = Array.prototype.slice.call(g.querySelectorAll('.mt-galeria__mini'));
      var contMinis = g.querySelector('.mt-galeria__minis');
      if (!slides.length) return;
      var actual = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-activa'); }));

      var ir = function (i) {
        actual = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-activa', k === actual); });
        minis.forEach(function (m, k) {
          m.classList.toggle('is-activa', k === actual);
          m.setAttribute('aria-current', k === actual ? 'true' : 'false');
        });
        var m = minis[actual];
        if (m && contMinis) {
          var horizontal = contMinis.scrollWidth > contMinis.clientWidth + 2;
          contMinis.scrollTo({
            left: horizontal ? m.offsetLeft - contMinis.clientWidth / 2 + m.clientWidth / 2 : 0,
            top: horizontal ? 0 : m.offsetTop - contMinis.clientHeight / 2 + m.clientHeight / 2,
            behavior: reducir ? 'auto' : 'smooth'
          });
        }
      };

      minis.forEach(function (m, k) { m.addEventListener('click', function () { ir(k); }); });
      var prev = g.querySelector('[data-mt-prev]');
      var next = g.querySelector('[data-mt-next]');
      if (prev) prev.addEventListener('click', function () { ir(actual - 1); });
      if (next) next.addEventListener('click', function () { ir(actual + 1); });

      var principal = g.querySelector('.mt-galeria__principal');
      var x0 = null;
      if (principal) {
        principal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        principal.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) ir(actual + (dx < 0 ? 1 : -1));
          x0 = null;
        });
      }

      document.addEventListener('mt:variante', function (e) {
        if (!e.detail || String(e.detail.producto) !== g.dataset.mtProducto || !e.detail.media) return;
        var i = slides.findIndex(function (s) { return s.dataset.mediaId === String(e.detail.media); });
        if (i > -1) ir(i);
      });
    });
  }

  /* ---------- Compra: packs, variantes, precio, cantidad ---------- */
  function initCompras(root) {
    root.querySelectorAll('[data-mt-compra]').forEach(function (caja) {
      if (listo(caja)) return;
      var datos = caja.querySelector('script[data-mt-variantes]');
      if (!datos) return;
      var variantes;
      try { variantes = JSON.parse(datos.textContent); } catch (err) { return; }

      var inputId = caja.querySelector('input[name="id"]');
      var boton = caja.querySelector('[data-mt-boton]');
      var botonTexto = caja.querySelector('[data-mt-boton-texto]');
      var precio = caja.querySelector('[data-mt-precio]');
      var tachado = caja.querySelector('[data-mt-tachado]');
      var ahorro = caja.querySelector('[data-mt-ahorro]');
      var packs = caja.querySelector('[data-mt-packs]');
      var opcion2 = caja.querySelector('[data-mt-opcion-2]');
      var prefijo1 = caja.querySelector('[data-mt-prefijo]');
      var pagoRapido = caja.querySelector('[data-mt-pago-rapido]');
      var error = caja.querySelector('.product-form__error-message-wrapper');
      var errorTexto = error ? error.querySelector('.product-form__error-message') : null;
      var dinero = formatoDinero(caja.dataset.mtMoneda);

      var buscar = function (sel) {
        return variantes.find(function (vr) {
          return vr.options.every(function (o, i) { return sel[i] == null || o === sel[i]; });
        });
      };
      var seleccion = function () {
        return Array.prototype.map.call(caja.querySelectorAll('[data-mt-opcion]'), function (fs) {
          var c = fs.querySelector('input:checked');
          return c ? c.value : null;
        });
      };
      var seleccion2 = function () {
        if (!opcion2) return seleccion();
        var c = opcion2.querySelector('input:checked');
        return c ? [c.value] : seleccion();
      };
      var pack = function () {
        var c = packs && packs.querySelector('input:checked');
        return c ? parseInt(c.value, 10) : 1;
      };

      var pintarPrecio = function (actual, comparado) {
        if (precio) precio.textContent = dinero(actual);
        var rebaja = comparado && comparado > actual;
        if (tachado) {
          tachado.hidden = !rebaja;
          if (rebaja) tachado.textContent = dinero(comparado);
        }
        if (ahorro) {
          ahorro.hidden = !rebaja;
          if (rebaja) ahorro.textContent = 'Ahorras ' + dinero(comparado - actual);
        }
      };

      var actualizar = function (inicial) {
        var n = pack();
        var sel = seleccion();

        caja.querySelectorAll('[data-mt-opcion]').forEach(function (fs, i) {
          var e = fs.querySelector('[data-mt-valor-elegido]');
          if (e) e.textContent = sel[i] || '';
        });
        if (opcion2) {
          opcion2.hidden = n !== 2;
          var e2 = opcion2.querySelector('[data-mt-valor-elegido]');
          var s2 = seleccion2();
          if (e2 && s2) e2.textContent = s2[0] || '';
        }
        if (prefijo1) prefijo1.hidden = n !== 2;
        if (pagoRapido) pagoRapido.hidden = n === 2;
        if (packs) {
          packs.querySelectorAll('.mt-pack').forEach(function (p) {
            p.classList.toggle('is-activo', p.querySelector('input').checked);
          });
        }

        var v = buscar(sel);
        var v2 = n === 2 ? buscar(seleccion2()) : v;
        if (!v || !v2) {
          if (boton) boton.disabled = true;
          if (botonTexto) botonTexto.textContent = caja.dataset.mtTextoNoDisponible;
          return;
        }
        if (inputId) inputId.value = v.id;

        var precioActual = v.price;
        if (n === 2 && packs) {
          var in2 = packs.querySelector('input[value="2"]');
          precioActual = parseInt(in2.dataset.precio, 10);
          pintarPrecio(precioActual, parseInt(in2.dataset.comparacion, 10));
        } else {
          pintarPrecio(v.price, v.compare_at_price);
        }

        var disponible = v.available && v2.available;
        if (boton) {
          boton.disabled = !disponible;
          boton.removeAttribute('aria-disabled');
        }
        if (botonTexto) botonTexto.textContent = disponible ? caja.dataset.mtTextoBoton : caja.dataset.mtTextoAgotado;
        if (inicial) return;

        if (caja.dataset.mtUrl === 'true' && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        document.dispatchEvent(new CustomEvent('mt:variante', {
          detail: { producto: caja.dataset.mtProducto, variante: v.id, media: v.featured_media ? v.featured_media.id : null, precio: precioActual }
        }));
      };

      caja.addEventListener('change', function (e) {
        if (e.target.closest('[data-mt-opcion], [data-mt-opcion-2], [data-mt-packs]')) actualizar(false);
      });

      caja.querySelectorAll('[data-mt-cant]').forEach(function (b) {
        b.addEventListener('click', function () {
          var inp = caja.querySelector('input[name="quantity"]');
          if (!inp) return;
          inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.dataset.mtCant, 10));
        });
      });

      // Pack de 2: se añaden las dos unidades (del mismo o distinto color) al carrito lateral de Dawn.
      var formEl = caja.querySelector('product-form');
      if (packs && formEl) {
        formEl.addEventListener('submit', function (e) {
          if (pack() !== 2) return;
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          if (!boton || boton.disabled || boton.getAttribute('aria-disabled') === 'true') return;

          var v = buscar(seleccion());
          var v2 = buscar(seleccion2());
          if (!v || !v2) return;
          var items = v.id === v2.id
            ? [{ id: v.id, quantity: 2 }]
            : [{ id: v.id, quantity: 1 }, { id: v2.id, quantity: 1 }];

          var carrito = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          var cuerpo = { items: items };
          if (carrito && carrito.getSectionsToRender) {
            cuerpo.sections = carrito.getSectionsToRender().map(function (s) { return s.id; });
            cuerpo.sections_url = window.location.pathname;
          }

          var spinner = boton.querySelector('.loading__spinner');
          if (error) error.hidden = true;
          boton.setAttribute('aria-disabled', 'true');
          boton.classList.add('loading');
          if (spinner) spinner.classList.remove('hidden');

          var urlAdd = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
          fetch(urlAdd, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(cuerpo)
          })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res.status) {
                if (error && errorTexto) { errorTexto.textContent = res.description || res.message || 'No se ha podido añadir.'; error.hidden = false; }
                return;
              }
              if (!carrito || !carrito.renderContents) {
                window.location = (window.routes && window.routes.cart_url) || '/cart';
                return;
              }
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mt-pack', productVariantId: v.id, cartData: res });
              }
              carrito.classList.remove('is-empty');
              if (carrito.setActiveElement) carrito.setActiveElement(boton);
              carrito.renderContents(res);
            })
            .catch(function () {
              if (error && errorTexto) { errorTexto.textContent = 'No se ha podido añadir. Inténtalo de nuevo.'; error.hidden = false; }
            })
            .finally(function () {
              boton.classList.remove('loading');
              boton.removeAttribute('aria-disabled');
              if (spinner) spinner.classList.add('hidden');
            });
        }, true);
      }

      actualizar(true);
    });

    document.querySelectorAll('[data-mt-barra-precio]').forEach(function (el) {
      if (listo(el)) return;
      var dinero = formatoDinero(el.dataset.mtMoneda);
      document.addEventListener('mt:variante', function (e) {
        if (!e.detail || String(e.detail.producto) !== el.dataset.mtProducto || !e.detail.precio) return;
        el.textContent = dinero(e.detail.precio);
      });
    });
  }

  /* ---------- Fecha estimada de entrega ---------- */
  function initEntregas(root) {
    root.querySelectorAll('[data-mt-entrega]').forEach(function (el) {
      if (listo(el)) return;
      var destino = el.querySelector('[data-mt-entrega-fechas]');
      if (!destino) return;
      var min = parseInt(el.dataset.min, 10) || 7;
      var max = parseInt(el.dataset.max, 10) || 14;
      var hoy = new Date();
      var d1 = new Date(hoy.getTime()); d1.setDate(hoy.getDate() + min);
      var d2 = new Date(hoy.getTime()); d2.setDate(hoy.getDate() + max);
      var mes;
      try {
        var fm = new Intl.DateTimeFormat('es-ES', { month: 'long' });
        mes = function (d) { return fm.format(d); };
      } catch (err) {
        mes = function (d) { return String(d.getMonth() + 1); };
      }
      destino.textContent = d1.getMonth() === d2.getMonth()
        ? 'entre el ' + d1.getDate() + ' y el ' + d2.getDate() + ' de ' + mes(d2)
        : 'entre el ' + d1.getDate() + ' de ' + mes(d1) + ' y el ' + d2.getDate() + ' de ' + mes(d2);
    });
  }

  /* ---------- Barra de compra fija (móvil) ---------- */
  function initBarra() {
    var barra = document.querySelector('[data-mt-barra]');
    var ancla = document.querySelector('[data-mt-barra-ancla]');
    if (!barra || !ancla || listo(barra) || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (entradas) {
      var e = entradas[0];
      barra.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    });
    obs.observe(ancla);
  }

  function init(root) {
    root = root || document;
    initReveals(root);
    initCifras(root);
    initParallax(root);
    initComparadores(root);
    initDetalles(root);
    initGalerias(root);
    initCompras(root);
    initEntregas(root);
    initBarra();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
